/**
 * 启动页 · 登录背景图 / 每日一句（无需登录即可访问）
 */
import { apiGet } from './http';

export interface DailyQuote {
  date: string;
  lines: string[];
  author: string;
  source: string;
  poemId: string;
}

export const listLoginBackgrounds = () =>
  apiGet<{ items: string[] }>('/splash/login-backgrounds');

export const getDailyQuote = () =>
  apiGet<DailyQuote | null>('/splash/daily-quote');
